import { render, staticRenderFns } from "./AuctionSettingsModal.vue?vue&type=template&id=513b7b86&scoped=true"
import script from "./AuctionSettingsModal.vue?vue&type=script&lang=js"
export * from "./AuctionSettingsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513b7b86",
  null
  
)

export default component.exports